import { SideNav, useLang } from "@manulife/mux";
import { Link, useLocation } from "react-router-dom";
import { Calculator } from '@manulife/mux-cds-icons';
import { changeLang } from "../../services/helpers/commonHelpers";
import LABELS from "../../assets/labels";

function IrSideNav({ setSelectedLang }) {
  const selectedLang = useLang();

  const { pathname } = useLocation();


  return (
    <SideNav
      activeKey={pathname}
      shouldCloseOnBlur={false}
      mobileFooterItems={[<SideNav.LangButton key="lang" onClick={() => changeLang(selectedLang)} />]}
      brandLogoProps={{ href: "/" }}
      wordmarkLogoProps={{ href: '#' }}
    >
      <SideNav.NavItem as={Link} style={{ textAlign: "center" }} id="insureRightCalculatorLink" label={LABELS.irCalculatorPageHeading[selectedLang]} to="/about" itemKey="/about" icon={<Calculator />} />
    </SideNav>
  );
}

export default IrSideNav;
